import DetailsCourseContainer from '../../../../Componant/Miscellaneous/Learning/DetailsCourse/DetailsCourse'

const DetailsCourse = () => {
  return (
    <div className='page-body'>
      <DetailsCourseContainer />
    </div>
  )
}

export default DetailsCourse